import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";


export function atividadesSemTalhao(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[], cod_propriedade_selecionada?: number, cod_talhao_selecionado?: number) {

    const propriedades_ativas = data_propriedades.filter(i => i.delete_time === null);

    // Filtrar propriedades pela selecionada
    const propriedades_filtradas = cod_propriedade_selecionada
        ? (propriedades_ativas ?? []).filter(i => i.cod === cod_propriedade_selecionada)
        : (propriedades_ativas ?? []);

    //@ts-ignore
    let todos_talhoes = propriedades_filtradas.flatMap(i => (i.talhao ?? []).map(t => ({ ...t, cod_propriedade: i.cod }))).filter(j => j.cod_talhao === null);

    // Filtrar talhão específico se selecionado
    if (cod_talhao_selecionado) {
        todos_talhoes = todos_talhoes.filter(i => i.cod_talhao === cod_talhao_selecionado);
    }

    // Filtrar talhões que NÃO possuem nenhum registro em data_atividades
    const talhoes_sem_atividade = todos_talhoes.filter(talhao =>
        !data_atividades.some(ativ =>
            ativ.cod_talhao === talhao.cod && ativ.cod_propriedade === talhao.cod_propriedade
        )
    );

    return {
        qtd: talhoes_sem_atividade.length,
        lista_talhoes: talhoes_sem_atividade
    }
}


export function talhoesForaDoComum(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[], cod_propriedade_selecionada?: number, cod_talhao_selecionado?: number, cod_subarea_selecionada?: number) {

    const propriedades_ativas = data_propriedades.filter(i => i.delete_time === null);
    const atividades_planejadas = (data_atividades ?? []).filter(i => i.cod_tipo === 1);

    //@ts-ignore
    let talhoes = (data_propriedades?.flat() ?? []).map(i => i.talhao)?.flat();

    // Filtrar propriedades pela selecionada
    const propriedades_filtradas = cod_propriedade_selecionada
        ? (propriedades_ativas ?? []).filter(i => i.cod === cod_propriedade_selecionada)
        : (propriedades_ativas ?? []);

    //@ts-ignore
    let todos_talhoes = propriedades_filtradas.flatMap(i => (i.talhao ?? []).map(t => ({ ...t, cod_propriedade: i.cod }))).filter(j => j.cod_talhao === null);

    // Filtrar talhão específico se selecionado
    if (cod_talhao_selecionado) {
        if (cod_subarea_selecionada) {
            todos_talhoes = todos_talhoes.filter(i => i.cod === cod_talhao_selecionado);
        } else {
            todos_talhoes = todos_talhoes.filter(i => i.cod === cod_talhao_selecionado || i.cod_talhao === cod_talhao_selecionado);
        }
    }

    let qtd_atvs_por_talhao = todos_talhoes.map(talhao => {
        const planejadas_talhao = atividades_planejadas.filter(ativ => ativ.cod_talhao === talhao.cod);
        return {
            nome_talhao: talhao.nome,
            is_subarea: (talhoes ?? []).some(i => i.cod === Number(talhao.cod_talhao)),
            nome_propriedade: data_propriedades.find(i => i.cod === talhao.cod_propriedade)?.nome,
            cod_talhao: talhao.cod,
            cod_propriedade: talhao.cod_propriedade,
            qtd_atividades: planejadas_talhao.length,
            atvs_planejadas: planejadas_talhao,
        }
    });

    const apenas_talhoes_com_atvs = qtd_atvs_por_talhao.filter(i => i.qtd_atividades > 0);

    const media_atvs = apenas_talhoes_com_atvs.reduce((acc, talhao) => acc + talhao.qtd_atividades, 0) / apenas_talhoes_com_atvs.length;

    const talhoes_com_mais_ou_menos_que_50_porcento_da_media = apenas_talhoes_com_atvs.filter(talhao => {
        return talhao.qtd_atividades < media_atvs * 0.5 || talhao.qtd_atividades > media_atvs * 1.5;
    }).map(talhao => {
        return {
            ...talhao,
            tipo_incomum: talhao.qtd_atividades < media_atvs * 0.5 ? '50% ou menos que a média' : 'Igual ou mais de 50% da média'
        }
    });

    return {
        qtd: talhoes_com_mais_ou_menos_que_50_porcento_da_media?.length,
        lista_talhoes: talhoes_com_mais_ou_menos_que_50_porcento_da_media,
        media_atvs: media_atvs
    }
}